

    <mat-card style="margin-top:30px;margin-left:10px;margin-right:0px;width:99%;">
        <mat-card-header>
            
        </mat-card-header>    
        <mat-card-content>

            <div class="box flex">
                <div class="row">
                    <div class="col-1">
                        <!-- <img src="../../../../../assets/ace-brand/ace-standard-logo.png" style="height:80px;"> -->
                        <img src="../../../../../assets/images/ace-standard-logo-100px.png" style="height:80px;">
                    </div>
                    <div class="col-11">
                        <div class="text-center" style="margin-bottom:10px;margin-left:20px;">
                            <span style="font-size: 24px;font-weight: bold;">ACE Parking Management - Monthly Parking Agreement</span>
                        </div>
                        <div class="text-center" style="margin-left:20px;">
                            <span style="font-size:18px">THIS CONTRACT LIMITS OUR LIABILITY-PLEASE READ IT CAREFULLY</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- <div class="flex box" style="margin:auto;">
                <div class="row">
                        <div class="col-1 text-end">
                            <img src="../../../../assets/ace-brand/ace-standard-logo.png" style="height:80px;">
                        </div>
                        <div class="col-5 text-left">
                            <div style="margin-bottom:10px;">
                                <span style="font-size: 24px;font-weight: bold;">ACE Parking Management - Monthly Parking Agreement</span>
                            </div>
                            <div >
                                <span style="font-size:18px">THIS CONTRACT LIMITS OUR LIABILITY-PLEASE READ IT CAREFULLY</span>
                            </div>
                        </div>
                    </div>
            </div> -->
            
            <div style="margin-top:15px;margin-bottom:15px;">
            &nbsp;
            @if(this.parkingAgreementData.includeLotSpecificContractVerbiage){
    
                <hr />
                <span style="font-size:18px;font-weight: bold;">Section A</span><br />
              
                <div [innerHTML]="lotSpecificContractVerbiage"></div>
              
                <span style="font-size:18px;font-weight: bold;">Section B</span><br />
    
                <div [innerHTML]="standardContractVerbiage" > </div>
            }
            @else{
    
                <div [innerHTML]="standardContractVerbiage"> </div>
            }
    
            <hr />
            @if(parkingAgreementData.defaultValueIncludeDataCollectionForm)
            {
                <div style="margin-left:30px;margin-right:30px;">
                    <!-- <app-vehicle-address-form [parkingAgreementData]="parkingAgreementData"></app-vehicle-address-form> -->
                </div>
            }
            @else 
            {
                <div style="margin-left:30px;margin-right:30px;">
                    <!-- <app-parking-agreement-signature [parkingAgreementData]="parkingAgreementData"></app-parking-agreement-signature> -->
                </div>
            }

            </div>
    
        </mat-card-content>
    </mat-card>
    
    
    
    
    

